/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Samples_Enter_Tracking_PlaceholderInputs */

const en_samples_enter_tracking_placeholder = /** @type {(inputs: Samples_Enter_Tracking_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter tracking number...`)
};

const es_samples_enter_tracking_placeholder = /** @type {(inputs: Samples_Enter_Tracking_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingrese numero de rastreo...`)
};

/**
* | output |
* | --- |
* | "Enter tracking number..." |
*
* @param {Samples_Enter_Tracking_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const samples_enter_tracking_placeholder = /** @type {((inputs?: Samples_Enter_Tracking_PlaceholderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Samples_Enter_Tracking_PlaceholderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_samples_enter_tracking_placeholder(inputs)
	return es_samples_enter_tracking_placeholder(inputs)
});